module.exports = __webpack_public_path__ + "src/img/baodao.50842120.svg";